<template>
  <!-- <div> -->
  <v-layout class="main">
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Por favor espere
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="col-left">
      <div 
        style="padding:50px;"
      >
        <v-img
          :src="'./img/logo.png'"
          @click="handleForceUpdate"
        />
      </div>
      <div 
        style="margin-bottom:20px;padding-left:50px;padding-right:50px;"
      >
        <v-card>
          <center class="card-header">
            {{totales && totales.LMD ? convertTime(totales.LMD) : ''}}
          </center>
          <chart 
            :categories="categories"
            :seriesValue="series"
          />
          <center style="margin-top:-30px">
            <table>
              <tr>
                <td style="padding-right:10px;">Día</td>
                <td>
                  <v-switch
                    v-model="errorByMonth"
                    :disabled="loading"
                  />
                </td>
                <td style="padding-left:10px;">Mes</td>
              </tr>
            </table>
          </center>
        </v-card>
      </div>
      <div 
        style="margin-top:50px;margin-bottom:20px;padding-left:50px;padding-right:50px;"
      >
        <v-card>
          <center class="card-header">
            Seguimiento específico por Unit ID
          </center>
          <specific-monitoring :devices="tks" />  
        </v-card>
      </div>
      <!-- <div 
        style="margin-bottom:20px;padding-left:50px;padding-right:50px;"
      >
        <v-card>
          <center class="card-header">
            Pendiente de asignar licencia
          </center>
          <no-subscriptions :devices="noSubscriptions" />  
        </v-card>
      </div> -->
    </div>
    <div class="col-right">
      <header-summary :totales="totales"/>
      <incidents
        :devices="incidents"
        :onChangeFilter="filterIncidents"
        :allDevices="incidentsFinal"
      />
    </div>
  </v-layout>
    <!-- <table width="100%" v-if="dataFinal">
      <tr>
        <td><center><b>NETWORK</b></center></td>
        <td><center><b>NAME</b></center></td>
        <td><center><b>GROUP</b></center></td>
        <td><center><b>F. ULT ERROR</b></center></td>
        <td><center><b>STATUS</b></center></td>
      </tr>
      <tr
        v-for="(item, index) in dataFinal"
        :key="index"
        :style="{ 'background-color':  item.status === 'Error' ? 'red' : item.status === 'NoSubscriptions' ? 'orange' : 'green' }"
      >
        <td><center>{{item.network}}</center></td>
        <td style="padding: 20px 10px 10px 10px;">{{item.name}}</td>
        <td><center>{{item.group.name}}</center></td>
        <td><center>{{convertTime(item.letime)}}</center></td>
        <td><center>{{item.status}}</center></td>
      </tr>
    </table>
  </div> -->
</template>

<script>
  import axios from 'axios'
  import oauth from 'axios-oauth-client'
  import convert from 'xml-js'
  import Chart from './Chart'
  import HeaderSummary from './HeaderSummary.vue'
  import SpecificMonitoring from './SpecificMonitoring'
  import NoSubscriptions from './NoSubscriptions'
  import Incidents from './Incidents'
  import api from '@/services/api'
  import utils from '@/services/utils'
  export default {
    name: 'Brightsignnetwork',
    components: {
      Chart,
      HeaderSummary,
      SpecificMonitoring,
      NoSubscriptions,
      Incidents
    },
    data () {
      return {
        totales: null,
        tks: null,
        incidents: null,
        noSubscriptions: null,
        dataFinal: null,
        data: [],
        incidentsFinal: null,
        categories: [],
        series: [],
        filterError: 0,
        filterDescription: null,
        errorByMonth: true,
        loading: false
      }
    },
    computed: {
      status () {
        return this.$route.query.status
      },
      group () {
        return this.$route.query.group
      },
      network () {
        return this.$route.query.network
      },
      name () {
        return this.$route.query.name
      },
    },
    watch: {
      errorByMonth () {
        this.getStats(true)
      }
    },
    mounted () {
      this.getData()
      window.setInterval(() => {
        this.data=[]
        this.getData()
      }, 300000)
      this.data = []
      this.getData()
    },
    methods: {
      getStats (showLoading = false) {
        if(showLoading) this.loading = true
        api.getAll('brightsign/stats'.concat(this.errorByMonth ? '?month=true' : '?day=true'), false).then(response => {
          this.categories = []
          this.series = []
          for (const item of response) {
            let aux = item.date.split('T')[0]
            aux = aux.split('-')
            if (this.errorByMonth) this.categories.push(utils.pad(aux[1]).concat(' / ', aux[0]))
            else this.categories.push(utils.pad(aux[2]).concat('/', utils.pad(aux[1]),'/', aux[0]))
            this.series.push(item.errors)
          }
          this.loading = false
        }) 
      },
      getData () {
        api.getAll('brightsign/total-header', false).then(response => {
          this.totales = {
            TotalPantalla: utils.formatNumber(response[0].TotalPantalla),
            Incidencia: utils.formatNumber(response[0].Incidencia),
            Mantenimiento: utils.formatNumber(response[0].Mantenimiento),
            Total: utils.formatNumber(response[0].Total),
            EnLinea: utils.formatNumber(response[0].EnLinea),
            LMD: response[0].LMD
          }
        })
        this.getStats()
        // api.getAll('brightsign/stats', false).then(response => {
        //   this.categories = []
        //   this.series = []
        //   for (const item of response) {
        //     let aux = item.date.split('T')[0]
        //     aux = aux.split('-')
        //     this.categories.push(utils.pad(aux[1]).concat(' / ', aux[0]))
        //     this.series.push(item.errors)
        //   }
        // })  
        api.getAll('brightsign/status', false).then(response => {
          this.tks = response.filter(x => x.tk)
          this.dataFinal = response.map ((item) => {
            item.downloadError = utils.getDownloadStatus(item.ldtime)
            item.statusColor = utils.getStatus(item.lctime)
            return item
          })
          this.incidentsFinal = response
          this.filterIncidents(this.filterError, this.filterDescription)
          // this.handleChangeFilterDescription([])
          // this.handleFilterError()
          // this.incidents = response.filter(x => 
          //                     x.status === 'Error' 
          //                     && !x.isMantenimiento
          //                   )
          this.noSubscriptions = response.filter(x => x.status === 'NoSubscriptions')
          // this.totales = response
        })
      },
      filterIncidents (filterError, filterDescription) {
        this.filterError = filterError
        this.filterDescription = filterDescription
        let aux = []
        if (filterDescription === null || filterDescription === undefined) {
          aux = this.incidentsFinal.filter(x => !x.isTralinkCero && !x.isMantenimiento && !x.isPendingInstallation && !x.isTemporalyClosed && !x.isRecover && !x.isVisionado)
        } else {
          if (filterDescription === 0) aux.push(...this.incidentsFinal.filter(x => x.isPendingInstallation))
          if (filterDescription === 1) aux.push(...this.incidentsFinal.filter(x => x.isTemporalyClosed))
          if (filterDescription === 2) aux.push(...this.incidentsFinal.filter(x => x.isRecover))
          if (filterDescription === 3) aux.push(...this.incidentsFinal.filter(x => x.isVisionado))
          if (filterDescription === 4) aux.push(...this.incidentsFinal.filter(x => x.isTralinkCero))
          if (filterDescription === 5) aux.push(...this.incidentsFinal.filter(x => x.status === 'NoSubscriptions'))
          if (filterDescription === 6) aux.push(...this.incidentsFinal)
        }
        switch (filterError) {
          case 0:
            this.incidents = aux.filter(x => x.status === 'Error')
            break
          case 1:
            this.incidents = aux.filter(x => x.statusColor.error)
            break
          case 2:
            this.incidents = aux.filter(x => x.downloadError)
            break
          case null:
            this.incidents = aux
            break
        }
      },
      convertTime(value) {
        const dt = new Date(value)
        const result = `${
                dt.getDate().toString().padStart(2, '0')}/${
                (dt.getMonth()+1).toString().padStart(2, '0')}/${
                dt.getFullYear().toString().padStart(4, '0')} ${
                dt.getHours().toString().padStart(2, '0')}:${
                dt.getMinutes().toString().padStart(2, '0')}:${
                dt.getSeconds().toString().padStart(2, '0')}`

        return result === '01/01/0001 00:00:00' ? '' : result
      },
      handleForceUpdate() {
        api.getAll('brightsign/force-update', false).then(response => {
          this.data=[]
          this.getData()
        })
      }
    }
  }
</script>

<style scoped>
  .main {
    position: absolute;
    background-color: rgba(237, 237, 237);
    width: 1920px;
    min-height: calc(100vh);
  }
  .col-left {
    position: relative;
    width: 610px;
  }
  .col-right {
    position: relative;
    width: 1310px;
  }
  .card-header {
    background-color: #90A4AE;
    color: white;
    font-size: 25px;
    padding: 10px 0;
  }
</style>
